import { render, staticRenderFns } from "./CRUDTableNationality.vue?vue&type=template&id=55ce7a42"
import script from "./CRUDTableNationality.vue?vue&type=script&lang=js"
export * from "./CRUDTableNationality.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableNationality.vue?vue&type=style&index=0&id=55ce7a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports